module.exports = __webpack_public_path__ + "9b9380a96ade6ab608a746e5c6339f0a.jpg";